export default __webpack_public_path__ + "static/media/emerging-factor-image.10b0d0f7.svg";